const isRune = (slug: string) => {
	return slug && slug.startsWith('rune-')
}

export default isRune
